<template>
  <div class="container" style="width: 85%">
    <h1
      id="welcometext"
      class="mb-12 h36-medium white--text"
      style="line-height: 96%"
    >
      {{ $t("homepage.login.left.subtitle") }}
    </h1>
    <h4 class="mb-12 h14-light white--text mt-6">
      <span v-html="$t('homepage.login.left.subtitlesub')"></span>
    </h4>
    <!--Timeline-->

    <v-timeline class="mt-4" dense>
      <v-timeline-item
        v-for="(item, i) in items"
        :key="i"
        :color="item.color"
        :icon="item.icon"
        fill-dot
        class="pb-0"
      >
        <v-row class="pt-2">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <strong class="white--text item-title">{{ item.title }}</strong>
            <div class="white--text caption">
              <span style="font-size: 13px">{{ item.content }}&nbsp;</span>
              <span :hidden="item.readMoreHidden" style="font-size: 13px"
                >{{ item.contentMore }}&nbsp;</span
              >
              <span style="font-size: 13px">
                <v-icon
                  :hidden="item.contentMore == null"
                  small
                  @click="item.readMoreHidden = !item.readMoreHidden"
                >
                  {{ item.readMoreHidden ? "expand_more" : "expand_less" }}
                </v-icon>
              </span>
            </div>
          </v-col>
        </v-row>
      </v-timeline-item>
    </v-timeline>

    <!--End Timeline -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      items: [
        {
          color: "primary",
          icon: "fast_forward",
          title: this.$t("homepage.login.timeline.title_1"),
          content: this.$t("homepage.login.timeline.subtitle_1"),
          contentMore: this.$t("homepage.login.timeline.subtitle_hidden_1"),
          readMoreHidden: true
        },
        {
          color: "primary",
          icon: "analytics",
          title: this.$t("homepage.login.timeline.title_2"),
          content: this.$t("homepage.login.timeline.subtitle_2"),
          contentMore: this.$t("homepage.login.timeline.subtitle_hidden_2"),
          readMoreHidden: true
        },
        {
          color: "primary",
          icon: "phone",
          title: this.$t("homepage.login.timeline.title_3"),
          content: this.$t("homepage.login.timeline.subtitle_3"),
          contentMore: this.$t("homepage.login.timeline.subtitle_hidden_3"),
          readMoreHidden: true
        }
      ]
    };
  },
  computed: {},
  methods: {},
  created() {}
};
</script>

<style scoped>
/*  Start Responsive screen */

@media only screen and (max-width: 800px) {
  .container {
    width: 93% !important;
  }
  #welcometext {
    line-height: 45px !important;
  }
}

@media only screen and (max-width: 600px) {
  .container {
    width: 90% !important;
  }
  #welcometext {
    line-height: 50px !important;
  }
}

@media only screen and (max-width: 480px) {
  .container {
    width: 88% !important;
  }
  #welcometext {
    line-height: 43px !important;
  }
}

@media only screen and (max-width: 414px) {
  #welcometext {
    line-height: 48px !important;
  }
}

@media only screen and (max-width: 412px) {
  #welcometext {
    line-height: 40px !important;
  }
}

@media only screen and (max-width: 400px) {
  .container {
    width: 84% !important;
  }
}

@media only screen and (max-width: 360px) {
  .container {
    width: 83% !important;
  }
}

@media only screen and (max-width: 240px) {
  .container {
    width: 75% !important;
  }
}
</style>
